export enum StillingTypeEnum {
    Sygehus = 1,
    Praksis = 2,
}
